import { SearchFilter } from "Components/AttendaceReport";
import SubHeader from "UI_Components/SubHeader";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./../../../assets/style/EmployeeProfile/EmployeeProfile.css";
import { Dropdown, MultiSelect } from "common/components";
import ProfileCard from "Components/EmployeeProfile/ProfileCard";
import apiManager from "networking/baseAPIManager";

const EmployeeProfile = () => {
  const [loading, setLoading] = useState(false);
  const [searchString, setSearchString] = useState("");
  const data = ["HTML", "CSS", "JAVASCRIPT", "REACT", "NODE", "PHP", "JAVA", "PYTHON"].map((item) => ({
    label: item,
    value: item,
  }));
  const [employeeOnleave, setEmployeeOnleave] = useState([]);
  const [employeeDetail, setEmployeeDetail] = useState([]);
  const [filteredApprovalData, setFilteredApprovalData] = useState([]);
  const [getDesignation, setDesignation] = useState([]);
  const [getDepartment, setDepartment] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");

  useEffect(() => {
    fetchEmployeesOnLeave();
  }, []);
  const location = useLocation();
  const flagFromAttendance = location.state;
  const fetchEmployeesOnLeave = () => {
    setLoading(true);
  };

  const getDesignationList = () => {
    setLoading(true);

    apiManager
      .getDropdownTypes("designation")
      .then((response) => {
        setLoading(false);
        setDesignation(response?.data?.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getDesignationList();
  }, []);
  const getDepartmentList = () => {
    setLoading(true);

    apiManager
      .getDropdownTypes("department")
      .then((response) => {
        setLoading(false);
        setDepartment(response?.data?.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getDepartmentList();
  }, []);
  useEffect(() => {
    setLoading(true);
    let status;

    if (flagFromAttendance === "leave") {
      status = "?status=onleave";
    } else {
      status = "?status=active";
    }

    apiManager
      .activeEmployeeList(status)
      .then((response) => {
        setLoading(false);
        if (status === "?status=onleave") {
          setEmployeeOnleave(response.data);
        } else {
          setEmployeeDetail(response.data);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, [flagFromAttendance]);

  useEffect(() => {
    if (searchString) {
      const result = employeeDetail.filter((rowObj) => {
        return (
          rowObj.employeeID.toLowerCase().includes(searchString.toLowerCase()) ||
          rowObj.firstname.toLowerCase().includes(searchString.toLowerCase())
        );
      });
      setFilteredApprovalData(result);
    } else {
      setFilteredApprovalData(employeeDetail);
    }
  }, [employeeDetail, searchString]);

  useEffect(() => {
    if (selectedDesignation !== "All") {
      const filteredEmployees = employeeDetail.filter((employee) => employee?.designation === selectedDesignation);
      setFilteredApprovalData(filteredEmployees);
    } else {
      setFilteredApprovalData(employeeDetail);
    }
  }, [selectedDesignation]);
  useEffect(() => {
    if (selectedDepartment !== "All") {
      const filteredEmployees = employeeDetail.filter((employee) => employee?.department === selectedDepartment);
      setFilteredApprovalData(filteredEmployees);
    } else {
      setFilteredApprovalData(employeeDetail);
    }
  }, [selectedDepartment]);
  return (
    <div>
      <SubHeader location={useLocation()} />
      <div className="row m-0 p-0">
        <div className="col-lg-3 mt-4">
          <SearchFilter data={searchString} setSearchString={setSearchString} placeholder={"Name or EmpId"} />
        </div>
        <div className="col-lg-3 mt-4">
          <Dropdown
            value={selectedDesignation}
            valueKey="id"
            options={getDesignation}
            onChange={(e) => setSelectedDesignation(e.target.value)}
            placeholder="Select Designation"
          />
        </div>
        <div className="col-lg-3 mt-4">
          <Dropdown
            value={selectedDepartment}
            valueKey="id"
            options={getDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            placeholder="Select Department"
          />
        </div>
      </div>
      <div className="row m-0 pt-3 ">
        <div className="col-lg-12 ">
          <ProfileCard
            flagFromAttendance={flagFromAttendance}
            filteredApprovalData={filteredApprovalData}
            employeeOnleave={employeeOnleave}
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeeProfile;
